import moment from 'moment-timezone';
import _get from 'lodash/get';

const calendar = {
  /* Month View */
  monthYearFormatted(state) {
    return moment(state.startDate).format('MMMM YYYY');
  },
  monthDateISOFormat(state) {
    return moment(state.startDate).format('YYYY-MM');
  },
  todayDateISOFormat(state) {
    return moment().format('YYYY-MM-DD');
  },
  /* Agenda View */
  startDateISOFormat(state) {
    return moment(state.startDate).format('YYYY-MM-DD');
  },
  endDateISOFormat(state) {
    return moment(state.endDate).format('YYYY-MM-DD');
  },
  startDateFormatted(state) {
    return moment(state.startDate).format('MMMM D, YYYY');
  },
  endDateFormatted(state) {
    return moment(state.endDate).format('MMMM D, YYYY');
  },
};

const getters = {
  getTempVal(state, path) {
    return (path) => {
      return _get(state, path, null);
    };
  },
  ...calendar,
};

export default getters;
